import { PriceData } from '@pythnetwork/client'
import { LAMPORTS_PER_SOL } from '@solana/web3.js'
import { ArbToken } from '../types'

export function numberWithCommas(num: number): string {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export function getCollateralAsNumber(collateral: string): number {
  if (parseFloat(collateral)) {
    return parseFloat(collateral)
  } else {
    return 0
  }
}

export function validNumericTrailingCharCheck(text: string) {
  const filtered = text.replaceAll(/[^0-9.]/g, '')
  if (filtered.slice(0, -1).match(/\./) && filtered.slice(-1) === '.') {
    // trailing period when a period is already in the text
    return filtered.slice(0, -1)
  } else {
    return filtered
  }
}

export function calculateLoanAmount(
  collateral: number,
  solPrice: PriceData | null
): string {
  if (collateral > 0 && solPrice) {
    const depositValue = solPrice.price * collateral
    const loanEst = parseFloat((depositValue / 1.5).toFixed(5))
    const internationalNumberFormat = new Intl.NumberFormat('en-US')
    return (
      internationalNumberFormat.format(collateral).toString() +
      ' * ' +
      ' $' +
      internationalNumberFormat.format(solPrice.price).toString() +
      ' / 1.5 = ' +
      internationalNumberFormat.format(loanEst).toString()
    )
  } else {
    return '0'
  }
}

export function calculateArbAmount(
  amount: number,
  priceData: PriceData | null,
  arbToken: ArbToken
): string {
  if (amount > 0 && priceData) {
    const swapEstimate = parseFloat((amount / priceData.price).toFixed(5))
    const internationalNumberFormat = new Intl.NumberFormat('en-US')
    return (
      internationalNumberFormat.format(amount).toString() +
      ' ' +
      arbToken +
      ' ' +
      ' / ' +
      ' $' +
      internationalNumberFormat.format(priceData.price).toString() +
      ' = ' +
      internationalNumberFormat.format(swapEstimate).toString()
    )
  } else {
    return '0'
  }
}

export function calculateArbAmountKong(
  amount: number,
  priceData: PriceData | null,
  arbToken: ArbToken
): string {
  if (amount > 0 && priceData) {
    const swapEstimate = parseFloat((amount * priceData.price).toFixed(5))
    const internationalNumberFormat = new Intl.NumberFormat('en-US')
    return (
      internationalNumberFormat.format(amount).toString() +
      ' ' +
      arbToken +
      ' ' +
      ' * ' +
      ' $' +
      internationalNumberFormat.format(priceData.price).toString() +
      ' = ' +
      internationalNumberFormat.format(swapEstimate).toString()
    )
  } else {
    return '0'
  }
}

export function format5Dec(balance: number, divisor?: number): string {
  return balance === null
    ? '--'
    : (Math.round((balance / (divisor || 1)) * 1e5) / 1e5).toString()
}

export function numLamportsToSol(amount: number): number {
  return amount / LAMPORTS_PER_SOL
}
